export default __webpack_public_path__ + "static/media/info_black_24dp.93850f83.svg";